import { useMemo } from 'react';

import { useIntl } from 'react-intl';

import type { ApplicationModes } from '../../../common/constants/application-modes';
import { type ProductKeys } from '../../../common/constants/products';

import { skeletonPlaceholders } from './skeleton-placeholders';
import { ghostTextInputPlaceholders, useGhostTextSessionCount } from './utils';

export type UsePlaceholderTextProps = {
	applicationMode: ApplicationModes;
	isAdminHubAIEnabled: boolean;
	isNav4Enabled: boolean;
	quickFindOpen: boolean;
	availableProducts: ProductKeys[];
};

/**
 * Deprecated: This is used in non-nav4 and non-relay and basically legacy component
 */
export const usePlaceholderText: ({}: UsePlaceholderTextProps) => {
	placeholder: string;
	incrementSession: () => void;
	ghostTextSession: number;
} = ({}: UsePlaceholderTextProps) => {
	const { formatMessage } = useIntl();
	const [ghostTextSession, { incrementSession }] = useGhostTextSessionCount({
		initialValue: 0,
		maxCount: ghostTextInputPlaceholders.length,
	});

	const placeholder = useMemo(() => {
		return formatMessage(skeletonPlaceholders.inputPlaceholder);
	}, [formatMessage]);

	return { placeholder, incrementSession, ghostTextSession };
};
